module.exports = __webpack_public_path__ + "static/eu-fund-7c1681a011a71e9f5c6b1baddf112ca6.png";